import { Box } from '@mui/material';

import AlipayIcon from '@/shared/assets/icons/payment-methods/alipay.svg';
import ApplePayIcon from '@/shared/assets/icons/payment-methods/apple-pay.svg';
import CashPayIcon from '@/shared/assets/icons/payment-methods/cashpay.svg';
import GooglePayIcon from '@/shared/assets/icons/payment-methods/google-pay.svg';
import LinkIcon from '@/shared/assets/icons/payment-methods/link.svg';
import MastercardIcon from '@/shared/assets/icons/payment-methods/mastercard.svg';
import VisaIcon from '@/shared/assets/icons/payment-methods/visa.svg';
import WechatIcon from '@/shared/assets/icons/payment-methods/wechat.svg';

export type PaymentMethodType =
  | 'alipay'
  | 'amex'
  | 'apple_pay'
  | 'card'
  | 'cashapp'
  | 'discover'
  | 'google_pay'
  | 'link'
  | 'mastercard'
  | 'us_bank_account'
  | 'visa'
  | 'wechat_pay';

type PaymentMethodIconProps = {
  brand?: string;
  type?: string;
};

const ICON_MAP: Record<string, string> = {
  alipay: AlipayIcon,
  apple_pay: ApplePayIcon,
  cashapp: CashPayIcon,
  google_pay: GooglePayIcon,
  link: LinkIcon,
  mastercard: MastercardIcon,
  visa: VisaIcon,
  wechat_pay: WechatIcon,
};

export const PaymentMethodIcon = ({ brand, type }: PaymentMethodIconProps) => {
  const iconKey = brand?.toLowerCase() || type?.toLowerCase() || '';
  const iconSrc = ICON_MAP[iconKey];

  if (!iconSrc) {
    return null;
  }

  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: 'white',
        display: 'flex',
        height: 24,
        justifyContent: 'center',
        overflow: 'hidden',
        width: 34,
      }}
    >
      <Box
        alt={iconKey}
        component="img"
        src={iconSrc}
        sx={{  objectFit: 'contain', width: 'auto' }}
      />
    </Box>
  );
};
